const v9600 = (Math.sqrt(3) - 1) * 0.5;
const v9601 = (3 - Math.sqrt(3)) / 6;
const v9602 = 1 / 3;
const v9603 = 1 / 6;
const v9604 = (Math.sqrt(5) - 1) / 4;
const v9605 = (5 - Math.sqrt(5)) / 20;
const vF84 = p12269 => Math.floor(p12269) | 0;
const v9606 = new Float64Array([1, 1, -1, 1, 1, -1, -1, -1, 1, 0, -1, 0, 1, 0, -1, 0, 0, 1, 0, -1, 0, 1, 0, -1]);
const v9607 = new Float64Array([1, 1, 0, -1, 1, 0, 1, -1, 0, -1, -1, 0, 1, 0, 1, -1, 0, 1, 1, 0, -1, -1, 0, -1, 0, 1, 1, 0, -1, 1, 0, 1, -1, 0, -1, -1]);
const v9608 = new Float64Array([0, 1, 1, 1, 0, 1, 1, -1, 0, 1, -1, 1, 0, 1, -1, -1, 0, -1, 1, 1, 0, -1, 1, -1, 0, -1, -1, 1, 0, -1, -1, -1, 1, 0, 1, 1, 1, 0, 1, -1, 1, 0, -1, 1, 1, 0, -1, -1, -1, 0, 1, 1, -1, 0, 1, -1, -1, 0, -1, 1, -1, 0, -1, -1, 1, 1, 0, 1, 1, 1, 0, -1, 1, -1, 0, 1, 1, -1, 0, -1, -1, 1, 0, 1, -1, 1, 0, -1, -1, -1, 0, 1, -1, -1, 0, -1, 1, 1, 1, 0, 1, 1, -1, 0, 1, -1, 1, 0, 1, -1, -1, 0, -1, 1, 1, 0, -1, 1, -1, 0, -1, -1, 1, 0, -1, -1, -1, 0]);
export function createNoise2D(p12270 = Math.random) {
  const vI19 = buildPermutationTable(p12270);
  const v9609 = new Float64Array(vI19).map(p12271 => v9606[p12271 % 12 * 2]);
  const v9610 = new Float64Array(vI19).map(p12272 => v9606[p12272 % 12 * 2 + 1]);
  return function (p12273, p12274) {
    let vLN01547 = 0;
    let vLN01548 = 0;
    let vLN01549 = 0;
    const v9611 = (p12273 + p12274) * v9600;
    const vVF84 = vF84(p12273 + v9611);
    const vVF842 = vF84(p12274 + v9611);
    const v9612 = (vVF84 + vVF842) * v9601;
    const v9613 = p12273 - (vVF84 - v9612);
    const v9614 = p12274 - (vVF842 - v9612);
    let v9615;
    let v9616;
    if (v9613 > v9614) {
      v9615 = 1;
      v9616 = 0;
    } else {
      v9615 = 0;
      v9616 = 1;
    }
    const v9617 = v9613 - v9615 + v9601;
    const v9618 = v9614 - v9616 + v9601;
    const v9619 = v9613 - 1 + v9601 * 2;
    const v9620 = v9614 - 1 + v9601 * 2;
    const v9621 = vVF84 & 255;
    const v9622 = vVF842 & 255;
    let v9623 = 0.5 - v9613 * v9613 - v9614 * v9614;
    if (v9623 >= 0) {
      const v9624 = v9621 + vI19[v9622];
      const v9625 = v9609[v9624];
      const v9626 = v9610[v9624];
      v9623 *= v9623;
      vLN01547 = v9623 * v9623 * (v9625 * v9613 + v9626 * v9614);
    }
    let v9627 = 0.5 - v9617 * v9617 - v9618 * v9618;
    if (v9627 >= 0) {
      const v9628 = v9621 + v9615 + vI19[v9622 + v9616];
      const v9629 = v9609[v9628];
      const v9630 = v9610[v9628];
      v9627 *= v9627;
      vLN01548 = v9627 * v9627 * (v9629 * v9617 + v9630 * v9618);
    }
    let v9631 = 0.5 - v9619 * v9619 - v9620 * v9620;
    if (v9631 >= 0) {
      const v9632 = v9621 + 1 + vI19[v9622 + 1];
      const v9633 = v9609[v9632];
      const v9634 = v9610[v9632];
      v9631 *= v9631;
      vLN01549 = v9631 * v9631 * (v9633 * v9619 + v9634 * v9620);
    }
    return (vLN01547 + vLN01548 + vLN01549) * 70;
  };
}
export function createNoise3D(p12275 = Math.random) {
  const vI20 = buildPermutationTable(p12275);
  const v9635 = new Float64Array(vI20).map(p12276 => v9607[p12276 % 12 * 3]);
  const v9636 = new Float64Array(vI20).map(p12277 => v9607[p12277 % 12 * 3 + 1]);
  const v9637 = new Float64Array(vI20).map(p12278 => v9607[p12278 % 12 * 3 + 2]);
  return function (p12279, p12280, p12281) {
    let v9638;
    let v9639;
    let v9640;
    let v9641;
    const v9642 = (p12279 + p12280 + p12281) * v9602;
    const vVF843 = vF84(p12279 + v9642);
    const vVF844 = vF84(p12280 + v9642);
    const vVF845 = vF84(p12281 + v9642);
    const v9643 = (vVF843 + vVF844 + vVF845) * v9603;
    const v9644 = p12279 - (vVF843 - v9643);
    const v9645 = p12280 - (vVF844 - v9643);
    const v9646 = p12281 - (vVF845 - v9643);
    let v9647;
    let v9648;
    let v9649;
    let v9650;
    let v9651;
    let v9652;
    if (v9644 >= v9645) {
      if (v9645 >= v9646) {
        v9647 = 1;
        v9648 = 0;
        v9649 = 0;
        v9650 = 1;
        v9651 = 1;
        v9652 = 0;
      } else if (v9644 >= v9646) {
        v9647 = 1;
        v9648 = 0;
        v9649 = 0;
        v9650 = 1;
        v9651 = 0;
        v9652 = 1;
      } else {
        v9647 = 0;
        v9648 = 0;
        v9649 = 1;
        v9650 = 1;
        v9651 = 0;
        v9652 = 1;
      }
    } else if (v9645 < v9646) {
      v9647 = 0;
      v9648 = 0;
      v9649 = 1;
      v9650 = 0;
      v9651 = 1;
      v9652 = 1;
    } else if (v9644 < v9646) {
      v9647 = 0;
      v9648 = 1;
      v9649 = 0;
      v9650 = 0;
      v9651 = 1;
      v9652 = 1;
    } else {
      v9647 = 0;
      v9648 = 1;
      v9649 = 0;
      v9650 = 1;
      v9651 = 1;
      v9652 = 0;
    }
    const v9653 = v9644 - v9647 + v9603;
    const v9654 = v9645 - v9648 + v9603;
    const v9655 = v9646 - v9649 + v9603;
    const v9656 = v9644 - v9650 + v9603 * 2;
    const v9657 = v9645 - v9651 + v9603 * 2;
    const v9658 = v9646 - v9652 + v9603 * 2;
    const v9659 = v9644 - 1 + v9603 * 3;
    const v9660 = v9645 - 1 + v9603 * 3;
    const v9661 = v9646 - 1 + v9603 * 3;
    const v9662 = vVF843 & 255;
    const v9663 = vVF844 & 255;
    const v9664 = vVF845 & 255;
    let v9665 = 0.6 - v9644 * v9644 - v9645 * v9645 - v9646 * v9646;
    if (v9665 < 0) {
      v9638 = 0;
    } else {
      const v9666 = v9662 + vI20[v9663 + vI20[v9664]];
      v9665 *= v9665;
      v9638 = v9665 * v9665 * (v9635[v9666] * v9644 + v9636[v9666] * v9645 + v9637[v9666] * v9646);
    }
    let v9667 = 0.6 - v9653 * v9653 - v9654 * v9654 - v9655 * v9655;
    if (v9667 < 0) {
      v9639 = 0;
    } else {
      const v9668 = v9662 + v9647 + vI20[v9663 + v9648 + vI20[v9664 + v9649]];
      v9667 *= v9667;
      v9639 = v9667 * v9667 * (v9635[v9668] * v9653 + v9636[v9668] * v9654 + v9637[v9668] * v9655);
    }
    let v9669 = 0.6 - v9656 * v9656 - v9657 * v9657 - v9658 * v9658;
    if (v9669 < 0) {
      v9640 = 0;
    } else {
      const v9670 = v9662 + v9650 + vI20[v9663 + v9651 + vI20[v9664 + v9652]];
      v9669 *= v9669;
      v9640 = v9669 * v9669 * (v9635[v9670] * v9656 + v9636[v9670] * v9657 + v9637[v9670] * v9658);
    }
    let v9671 = 0.6 - v9659 * v9659 - v9660 * v9660 - v9661 * v9661;
    if (v9671 < 0) {
      v9641 = 0;
    } else {
      const v9672 = v9662 + 1 + vI20[v9663 + 1 + vI20[v9664 + 1]];
      v9671 *= v9671;
      v9641 = v9671 * v9671 * (v9635[v9672] * v9659 + v9636[v9672] * v9660 + v9637[v9672] * v9661);
    }
    return (v9638 + v9639 + v9640 + v9641) * 32;
  };
}
export function createNoise4D(p12282 = Math.random) {
  const vI21 = buildPermutationTable(p12282);
  const v9673 = new Float64Array(vI21).map(p12283 => v9608[p12283 % 32 * 4]);
  const v9674 = new Float64Array(vI21).map(p12284 => v9608[p12284 % 32 * 4 + 1]);
  const v9675 = new Float64Array(vI21).map(p12285 => v9608[p12285 % 32 * 4 + 2]);
  const v9676 = new Float64Array(vI21).map(p12286 => v9608[p12286 % 32 * 4 + 3]);
  return function (p12287, p12288, p12289, p12290) {
    let v9677;
    let v9678;
    let v9679;
    let v9680;
    let v9681;
    const v9682 = (p12287 + p12288 + p12289 + p12290) * v9604;
    const vVF846 = vF84(p12287 + v9682);
    const vVF847 = vF84(p12288 + v9682);
    const vVF848 = vF84(p12289 + v9682);
    const vVF849 = vF84(p12290 + v9682);
    const v9683 = (vVF846 + vVF847 + vVF848 + vVF849) * v9605;
    const v9684 = p12287 - (vVF846 - v9683);
    const v9685 = p12288 - (vVF847 - v9683);
    const v9686 = p12289 - (vVF848 - v9683);
    const v9687 = p12290 - (vVF849 - v9683);
    let vLN01550 = 0;
    let vLN01551 = 0;
    let vLN01552 = 0;
    let vLN01553 = 0;
    if (v9684 > v9685) {
      vLN01550++;
    } else {
      vLN01551++;
    }
    if (v9684 > v9686) {
      vLN01550++;
    } else {
      vLN01552++;
    }
    if (v9684 > v9687) {
      vLN01550++;
    } else {
      vLN01553++;
    }
    if (v9685 > v9686) {
      vLN01551++;
    } else {
      vLN01552++;
    }
    if (v9685 > v9687) {
      vLN01551++;
    } else {
      vLN01553++;
    }
    if (v9686 > v9687) {
      vLN01552++;
    } else {
      vLN01553++;
    }
    const v9688 = vLN01550 >= 3 ? 1 : 0;
    const v9689 = vLN01551 >= 3 ? 1 : 0;
    const v9690 = vLN01552 >= 3 ? 1 : 0;
    const v9691 = vLN01553 >= 3 ? 1 : 0;
    const v9692 = vLN01550 >= 2 ? 1 : 0;
    const v9693 = vLN01551 >= 2 ? 1 : 0;
    const v9694 = vLN01552 >= 2 ? 1 : 0;
    const v9695 = vLN01553 >= 2 ? 1 : 0;
    const v9696 = vLN01550 >= 1 ? 1 : 0;
    const v9697 = vLN01551 >= 1 ? 1 : 0;
    const v9698 = vLN01552 >= 1 ? 1 : 0;
    const v9699 = vLN01553 >= 1 ? 1 : 0;
    const v9700 = v9684 - v9688 + v9605;
    const v9701 = v9685 - v9689 + v9605;
    const v9702 = v9686 - v9690 + v9605;
    const v9703 = v9687 - v9691 + v9605;
    const v9704 = v9684 - v9692 + v9605 * 2;
    const v9705 = v9685 - v9693 + v9605 * 2;
    const v9706 = v9686 - v9694 + v9605 * 2;
    const v9707 = v9687 - v9695 + v9605 * 2;
    const v9708 = v9684 - v9696 + v9605 * 3;
    const v9709 = v9685 - v9697 + v9605 * 3;
    const v9710 = v9686 - v9698 + v9605 * 3;
    const v9711 = v9687 - v9699 + v9605 * 3;
    const v9712 = v9684 - 1 + v9605 * 4;
    const v9713 = v9685 - 1 + v9605 * 4;
    const v9714 = v9686 - 1 + v9605 * 4;
    const v9715 = v9687 - 1 + v9605 * 4;
    const v9716 = vVF846 & 255;
    const v9717 = vVF847 & 255;
    const v9718 = vVF848 & 255;
    const v9719 = vVF849 & 255;
    let v9720 = 0.6 - v9684 * v9684 - v9685 * v9685 - v9686 * v9686 - v9687 * v9687;
    if (v9720 < 0) {
      v9677 = 0;
    } else {
      const v9721 = v9716 + vI21[v9717 + vI21[v9718 + vI21[v9719]]];
      v9720 *= v9720;
      v9677 = v9720 * v9720 * (v9673[v9721] * v9684 + v9674[v9721] * v9685 + v9675[v9721] * v9686 + v9676[v9721] * v9687);
    }
    let v9722 = 0.6 - v9700 * v9700 - v9701 * v9701 - v9702 * v9702 - v9703 * v9703;
    if (v9722 < 0) {
      v9678 = 0;
    } else {
      const v9723 = v9716 + v9688 + vI21[v9717 + v9689 + vI21[v9718 + v9690 + vI21[v9719 + v9691]]];
      v9722 *= v9722;
      v9678 = v9722 * v9722 * (v9673[v9723] * v9700 + v9674[v9723] * v9701 + v9675[v9723] * v9702 + v9676[v9723] * v9703);
    }
    let v9724 = 0.6 - v9704 * v9704 - v9705 * v9705 - v9706 * v9706 - v9707 * v9707;
    if (v9724 < 0) {
      v9679 = 0;
    } else {
      const v9725 = v9716 + v9692 + vI21[v9717 + v9693 + vI21[v9718 + v9694 + vI21[v9719 + v9695]]];
      v9724 *= v9724;
      v9679 = v9724 * v9724 * (v9673[v9725] * v9704 + v9674[v9725] * v9705 + v9675[v9725] * v9706 + v9676[v9725] * v9707);
    }
    let v9726 = 0.6 - v9708 * v9708 - v9709 * v9709 - v9710 * v9710 - v9711 * v9711;
    if (v9726 < 0) {
      v9680 = 0;
    } else {
      const v9727 = v9716 + v9696 + vI21[v9717 + v9697 + vI21[v9718 + v9698 + vI21[v9719 + v9699]]];
      v9726 *= v9726;
      v9680 = v9726 * v9726 * (v9673[v9727] * v9708 + v9674[v9727] * v9709 + v9675[v9727] * v9710 + v9676[v9727] * v9711);
    }
    let v9728 = 0.6 - v9712 * v9712 - v9713 * v9713 - v9714 * v9714 - v9715 * v9715;
    if (v9728 < 0) {
      v9681 = 0;
    } else {
      const v9729 = v9716 + 1 + vI21[v9717 + 1 + vI21[v9718 + 1 + vI21[v9719 + 1]]];
      v9728 *= v9728;
      v9681 = v9728 * v9728 * (v9673[v9729] * v9712 + v9674[v9729] * v9713 + v9675[v9729] * v9714 + v9676[v9729] * v9715);
    }
    return (v9677 + v9678 + v9679 + v9680 + v9681) * 27;
  };
}
export function buildPermutationTable(p12291) {
  const vLN5122 = 512;
  const v9730 = new Uint8Array(vLN5122);
  for (let vLN01554 = 0; vLN01554 < vLN5122 / 2; vLN01554++) {
    v9730[vLN01554] = vLN01554;
  }
  for (let vLN01555 = 0; vLN01555 < vLN5122 / 2 - 1; vLN01555++) {
    const v9731 = vLN01555 + ~~(p12291() * (256 - vLN01555));
    const v9732 = v9730[vLN01555];
    v9730[vLN01555] = v9730[v9731];
    v9730[v9731] = v9732;
  }
  for (let vLN2562 = 256; vLN2562 < vLN5122; vLN2562++) {
    v9730[vLN2562] = v9730[vLN2562 - 256];
  }
  return v9730;
}